<template>
  <div data-component="app-launcher-options">
    <or-checkbox
      data-control="show-rc-versions"
      :model-value="settings.showRCVersions"
      :label="$t('HITL.app-launcher.options-show-rc-versions')"
      :disabled="isDisabled"
      @update:modelValue="onToggleShowRCVersions"
    />

    <or-checkbox
      data-control="skip-app-launcher"
      :model-value="settings.skipAppLauncher"
      :label="$t('HITL.app-launcher.options-skip-launcher')"
      :disabled="isDisabled"
      @update:modelValue="onToggleSkipAppLauncher"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue-demi';
import { OrCheckboxV3 as OrCheckbox } from '@onereach/ui-components-25';
import { APP_SETTINGS_PROP } from '../../constants';

export default defineComponent({
  name: 'AppLauncherOptions',
  components: { OrCheckbox },
  props: {
    settings: APP_SETTINGS_PROP,
    isDisabled: Boolean,
  },
  emits: ['settings-change'],
  methods: {
    onToggleShowRCVersions() {
      const changes = { showRCVersions: !this.settings.showRCVersions };
      this.$emit('settings-change', { ...this.settings, ...changes });
    },
    onToggleSkipAppLauncher() {
      const changes = { skipAppLauncher: !this.settings.skipAppLauncher };
      this.$emit('settings-change', { ...this.settings, ...changes });
    },
  },
});
</script>

<style lang="scss" scoped>
[data-component='app-launcher-options'] {
  display: flex;
  flex-direction: column;
  gap: var(--s-4);
}
</style>
